import { config } from '@uhg-abyss/web/tools/config';
import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';

export const getUserInfoRequest = async () => {
  const response = await http({
    method: 'GET',
    // withCredentials: true,
    url: `${config('IDENTITY_API_URL')}/userinfo`,
    handleError: (err) => {
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);

  return data;
};

export const validateUserRequest = async () => {
  const response = await http({
    id: 'validate-user',
    resource: 'utility',
    method: 'GET',
    cache: false,
    withCredentials: true,
    url: `${config('LINK_EPV_API_URL')}/superUser/v1`,
    handleError: (err) => {
      const { duration, endpoint, message, data, status } = err;
      const errorData = {
        message: data?.error?.description || message,
        code: status,
        duration,
        endpoint,
      };
      eapmEvent('EAPM_TRANSACTION_ERROR', errorData);
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);

  return data;
};
